import { MonthlyStockUpload } from '../../../../interfaces/monthlyStock.interface';
import { Validation } from '../../../../interfaces/common';
import { VALIDATION_FIELD_MAPPING, APP_ERROR_MESSAGES } from '../../../../utils/appConstant';

const ALLOWED_FILE_EXTENSIONS = ['.xlsx', '.xls', '.txt'];

const getFileExtension = (file: File): string => {
  const name = file.name.toLowerCase();
  const dotIndex = name.lastIndexOf('.');
  return dotIndex !== -1 ? name.slice(dotIndex) : '';
};

export const validateMonthlyStockForm = (
  formData: MonthlyStockUpload,
  fieldToValidate?: string
): Validation => {
  const validations: Validation = { validate: true, fields: [] };

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.stockist) {
    if (!formData.stockist) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.stockist,
        message: APP_ERROR_MESSAGES.monthlyStock.addEdit.blankStockist,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.branch) {
    if (!formData.branch) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.branch,
        message: APP_ERROR_MESSAGES.monthlyStock.addEdit.blankBranch,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.month) {
    if (!formData.month) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.month,
        message: APP_ERROR_MESSAGES.monthlyStock.addEdit.blankMonth,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.year) {
    if (!formData.year) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.year,
        message: APP_ERROR_MESSAGES.monthlyStock.addEdit.blankYear,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.file) {
    if (!formData.file) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.file,
        message: APP_ERROR_MESSAGES.monthlyStock.addEdit.blankFile,
      });
    } else if (!ALLOWED_FILE_EXTENSIONS.includes(getFileExtension(formData.file))) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.file,
        message: APP_ERROR_MESSAGES.monthlyStock.addEdit.invalidFileType,
      });
    }
  }

  return validations;
};
